import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { fetchIssue } from "../../../Utils/firebaseServices";
import ShowIssuesComment from "./ShowIssuesComment";
import Layout from "../Layout"; // Import your Layout component
import { Container, Card, Typography, CircularProgress } from "@mui/material";
import LoadingCircular from "../../../loader/LoadingCircular";

const ShowIssuesList = () => {
  const { issueId } = useParams();
  const [issue, setIssue] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [loadingpage, setLoadingpage] = useState(true);

  const getIssueData = async () => {
    try {
      setLoadingpage(true)
      const issueData = await fetchIssue(issueId);
      setIssue(issueData);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
      setLoadingpage(false)
    }
  };
  
  useEffect(() => {
    getIssueData();
  }, [issueId]);
  
  if (loadingpage) {
    return <LoadingCircular />;
  } 

  if (loading) {
    return (
      <Layout>
        <Container style={{ textAlign: "center", marginTop: "50px" }}>
          <CircularProgress />
        </Container>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <Container>
          <Typography color="error">{error}</Typography>
        </Container>
      </Layout>
    );
  }
 
  return (
    <Container>
      <Card
        sx={{
          padding: "20px",
          border: "1px solid black",
          borderRadius: "4px",
          width: "81.5%",
          // maxWidth: "400px" //
        }}
      >
        <Typography variant="h5">{issue?.title || "Untitled Issue"}</Typography>
        <Typography>Type: {issue?.type || "N/A"}</Typography>
        <Typography>Opened: {issue?.opened || "N/A"}</Typography>
        <Typography>
          Tags:{" "}
          {issue?.tags?.length ? issue.tags.join(", ") : "No tags available"}
        </Typography>
        <Typography>
          Comments:{" "}
          {issue?.commentId?.length
            ? issue.commentId.join(", ")
            : "No comments available"}
        </Typography>
      </Card>
      <ShowIssuesComment />
    </Container>
  );
};

export default ShowIssuesList;
